<template>
    <div>
        <div class="user-bar">
            <div class="panel-item hidden-sm-and-down" @click="search">
                <el-icon><el-icon-search /></el-icon>
            </div>
            <div class="screen panel-item hidden-sm-and-down" @click="toScreenfull">
                <el-icon><el-icon-full-screen /></el-icon>
            </div>
            <el-dropdown class="user panel-item" trigger="click" @command="handleUser">
                <div class="user-avatar">
                    <label>{{ client.username }}</label>
                    <el-icon class="el-icon--right"><el-icon-arrow-down /></el-icon>
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="uc">帐号信息</el-dropdown-item>
                        <el-dropdown-item command="clearCache">清除缓存</el-dropdown-item>
                        <el-dropdown-item divided command="outLogin">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <el-dialog v-model="searchVisible" :width="700"  title="搜索" center destroy-on-close>
            <search @success="searchVisible = false"></search>
        </el-dialog>
    </div>
</template>

<script>
    import Search from './search'
    import { reactive, watch, toRefs, nextTick, defineComponent, getCurrentInstance, ref, computed } from 'vue'
    import { useUserStore } from '@/store'
    import Screenfull from '@/utils/screenfull'
    import Cache from '@/utils/cache'

    export default defineComponent({
        components: {
            Search
        },
        setup() {
            const searchVisible = ref(false)
            const StoreUser = useUserStore()
            const { proxy } = getCurrentInstance()
            const client = computed(() => StoreUser.client)
            const handleUser = (command) => {
                if (command === 'uc') {
                    proxy.$router.push({
                        path: '/store/user/myinfo'
                    })
                }
                if (command === 'cmd') {
                    proxy.$router.push({ path: '/cmd' })
                }
                if (command === 'clearCache') {
                    proxy.jiu.modal('温馨提示', '清除缓存会将系统初始化，包括登录状态、主题、语言设置等，是否继续？', true, (e) => {
                        if (e) {
                            Cache.clear()
                            proxy.$router.replace({ path: '/store/public/login' })
                            setTimeout(() => {
                                location.reload()
                            }, 1000)
                        }
                    }, 'warning')
                }
                if (command === 'outLogin') {
                    proxy.jiu.modal('温馨提示', '确认是否退出当前用户？', true, (e) => {
                        if (e) {
                            Cache.clear()
                            proxy.$router.replace({ path: '/store/public/login' })
                            setTimeout(() => {
                                location.reload()
                            }, 1000)
                        }
                    }, 'warning')
                }
            }
            // 全屏
            const toScreenfull = () => {
                Screenfull.toggle()
            }
            // 搜索
            const search = () => {
                searchVisible.value = true
            }
            return {
                toScreenfull,
                handleUser,
                client,

                search,
                searchVisible
            }
        }
    })
</script>

<style scoped>
    .user-bar {display: flex;align-items: center;height: 100%;}
    .user-bar .panel-item {padding: 0 10px;cursor: pointer;height: 100%;display: flex;align-items: center;}
    .user-bar .panel-item i {font-size: 16px;}
    .user-bar .panel-item:hover {background: rgba(0, 0, 0, 0.1);}
    .user-bar .user-avatar {height:49px;display: flex;align-items: center;}
    .user-bar .user-avatar label {display: inline-block;margin-left:5px;font-size: 12px;cursor:pointer;}

    .msg-list li {border-top:1px solid #eee;}
    .msg-list li a {display: flex;padding:20px;}
    .msg-list li a:hover {background: #ecf5ff;}
    .msg-list__icon {width: 40px;margin-right: 15px;}
    .msg-list__main {flex: 1;}
    .msg-list__main h2 {font-size: 15px;font-weight: normal;color: #333;}
    .msg-list__main p {font-size: 12px;color: #999;line-height: 1.8;margin-top: 5px;}
    .msg-list__time {width: 100px;text-align: right;color: #999;}

    .dark .msg-list__main h2 {color: #d0d0d0;}
    .dark .msg-list li {border-top:1px solid #363636;}
    .dark .msg-list li a:hover {background: #383838;}
</style>
